import {setWith, clone, get} from 'lodash';

// to check the concept read https://github.com/rtfeldman/seamless-immutable
export const immutableSetIn = (obj, path, data) => setWith(clone(obj), path, data, clone);

export const immutableMergeIn = (obj, path, data) => {
  const existing = get(obj, path);
  return immutableSetIn(obj, path, {...existing, ...data});
};
